import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SHARED_API_BASE_PATH } from 'sg-api';
import { BILL_API_BASE_PATH } from 'sg-api';
import { EEC_API_BASE_PATH } from 'sg-api';
import { FF_API_BASE_PATH } from 'sg-api';
import { PROV_API_BASE_PATH } from 'sg-api';
import { environment, authCodeFlowConfig, authInterceptTargetUrl } from '../environments/environment';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule, NativeDateAdapter } from '@angular/material/core';
import { AppRoutingModule } from './app-routing.module';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { SharedModule } from 'cbc-shared-lib';
import { LoadingInterceptor } from 'cbc-shared-lib';
import { LoadingService } from 'cbc-shared-lib';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { DatePipe } from '@angular/common';
import { AuthSessionInterceptor } from 'cbc-shared-lib';
import { ToastrModule } from 'ngx-toastr';
import { OAuthModule } from 'angular-oauth2-oidc';
import { FeaturesModule } from 'sg-features';
import { MainComponent } from './pages/main/main.component';
import { CisCommonModule } from 'sg-features';
import { MatDialogModule } from '@angular/material/dialog';

/**
 * ルートモジュール
 * @export
 * @class AppModule
 */
@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatSnackBarModule,
    AppRoutingModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    CisCommonModule,
    MatDialogModule,
    ToastrModule.forRoot(),
    OAuthModule.forRoot(),
    FeaturesModule.forRoot({
      httpTimeout: environment.HTTP_TIMEOUT,
      aceptbaseUiBasePath: environment.ACEPTBASE_UI_BASE_PATH,
    }),
    SharedModule.forRoot({
      authCodeFlowConfig: authCodeFlowConfig,
      authInterceptTargetUrl: authInterceptTargetUrl,
      httpTimeout: environment.HTTP_TIMEOUT,
      production: environment.production
    }),
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'ja-JP' },
    LoadingService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthSessionInterceptor,
      multi: true,
    },
    // 現状、サービスがすべてルートインジェクターに登録されているため、変数の設定はここで行う必要がある。
    // ※遅延ロードされるモジュールで設定しても反映されない
    { provide: SHARED_API_BASE_PATH, useValue: environment.SHARED_API_BASE_PATH },
    { provide: BILL_API_BASE_PATH, useValue: environment.BILL_API_BASE_PATH },
    { provide: EEC_API_BASE_PATH, useValue: environment.EEC_API_BASE_PATH },
    { provide: FF_API_BASE_PATH, useValue: environment.FF_API_BASE_PATH },
    { provide: PROV_API_BASE_PATH, useValue: environment.PROV_API_BASE_PATH },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
